import React from 'react';
import { Home, Tag, BookOpen, Users } from 'lucide-react';
export function IntentLinks() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-188">
      <h2 className="text-2xl font-serif text-brand-dark mb-6 text-center" data-id="element-189">
        How can Marcus help?
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-190">
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-191">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-192">
            <Tag size={22} data-id="element-193" />
          </div>
          <div data-id="element-194">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-195">
              Selling a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-196">
              Every path to sell, one agent
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-197">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-198">
            <Home size={22} data-id="element-199" />
          </div>
          <div data-id="element-200">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-201">
              Buying a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-202">
              Matched by results in your neighborhood
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-203">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-204">
            <BookOpen size={22} data-id="element-205" />
          </div>
          <div data-id="element-206">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-207">
              Marcus Chen on Stan
            </p>
            <p className="text-sm text-brand-muted" data-id="element-208">
              Courses, guides & resources
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-209">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-210">
            <Users size={22} data-id="element-211" />
          </div>
          <div data-id="element-212">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-213">
              Join Our Team
            </p>
            <p className="text-sm text-brand-muted" data-id="element-214">
              Interested in joining the Chen Real Estate Group?
            </p>
          </div>
        </a>
      </div>
    </section>;
}